module.exports = __webpack_public_path__ + "img/15.09bef13b.jpg";